import $ from 'jquery';
import _ from 'underscore';
import {loadStories} from '../api/api';

export default class News {
	constructor(options) {
		const defaults = {
			el: '.js-news-event',

			dom: {
				container: '.js-card-event-container',
				selectDate: '.js-select-data',
				selectType: '.js-select-type',
				select: '.js-select-item',
				selectVal: '.js-select-input',
				showMore: '.js-show-more'
			},
			loadTypes: {
				new: 'new',
				showMore: 'showMore'
			}
		};
		this.forms = [
			document.querySelector('#news-event-form'),
			document.querySelector('#news-event-mobile-form')
		];

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.filterDate = '';
		this.filterType = '';
		this.showCount = 0;
		this.showCountStep = 9;
		this.countInLine = 3;
		return this;

	}

	getDom() {

		const mustacheStyleSyntax = {
			evaluate: /\{\{(.+?)\}\}/g,
			interpolate: /\{\{=(.+?)\}\}/g,
			escape: /\{\{-(.+?)\}\}/g
		};
		const dom = this.options.dom;
		const $tmpl = $('#cardEventTmp').clone();
		$('#cardEventTmp').remove();
		$('#cardEventTmp').remove();
		this.$cardEventTmp = _.template(_.unescape($tmpl.html().trim()), mustacheStyleSyntax);
		this.$container = this.$el.find(dom.container);
		this.$selectDate = $(dom.selectDate);
		this.$selectType = $(dom.selectType);
		this.$select = $(dom.select);
		this.$showMoreButton = this.$el.find(dom.showMore);

		return this;
	}

	resize() {
		const docWidth = $(document).width();
		const $children = this.$container.eq(1).children();

		if (docWidth > 768) {

			this.countInLine = 3;

		} else if (docWidth < 768 && docWidth > 320) {

			this.countInLine = 2;

		} else if (docWidth < 320) {

			this.countInLine = 1;

		}

		if ($children.length % this.countInLine !== 0 ) {
			const index = ($children.length - $children.length % this.countInLine) - 1;
			$children.each(item => {
				$children.eq(item).css('display', 'block');
				if (item > index) { console.log($children.eq(item));
					$children.eq(item).css('display', 'none');
				}
			});
		}

	}

	getNews() {
		const sourceUrl = this.$el.data('source') || '';

		loadStories(this.completeFilters(), sourceUrl)
			.then(data => this.renderNews(data))
			.catch(data => console.log(data));
	}

	formatData(data, formData) {
		if (formData.length) {
			formData.map(function (item) {
				data[item.name] = item.value;
			});
		}
		return data;
	}

	completeFilters() {
		const index = $(document).width() < 1024 ? 1 : 0;
		const formData = $(this.forms[index]).serializeArray();

		const data = {
			offset: this.showCount,
			countInLine: this.countInLine,
			count: this.showCountStep
		};

		return this.formatData(data, formData);
	}

	showMore() {
		this.getNews();
	}

	selectNews() {
		this.showCount = 0;
		this.$container.empty();
		setTimeout(() => {
			this.getNews();
		});
	}

	renderNews(data) {
		data.items.forEach( item => {
			this.$container.append(this.$cardEventTmp({data: item}));
		});

		this.showCount += data.items.length | 0;

		if ( data.count <= this.showCount ) {
			this.$showMoreButton.hide();
		} else {
			this.$showMoreButton.show();
		}

	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.resize();
			this.getNews();
			this.$showMoreButton.on('click', e => this.showMore(e));
			this.$select.on('click', e => this.selectNews(e));
			$(window).resize(e => this.resize(e));
		}
		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/news-event/news.js
 **/